import { useState } from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const InfoHint = ({ text, testId = "info-hint" }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          aria-label="Cos'è questa sezione"
          onClick={(e) => e.stopPropagation()}
          className="ml-1 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-muted-foreground/60 hover:text-[hsl(var(--primary))] transition-colors">
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" align="start"
                      className="max-w-xs border-border bg-card/95 p-3 text-xs leading-relaxed backdrop-blur">
        {text}
      </PopoverContent>
    </Popover>
  );
};
